import { trpc } from '../../config/trpc';

export const useAccountWebhooks = (accountId?: number) => {
  const utils = trpc.useUtils();
  const input = { account_id: accountId as number };
  const invalidateWebhooks = () => utils.getAccountWebhooksByAccount.invalidate(input);

  const { data: webhooks, isLoading } = trpc.getAccountWebhooksByAccount.useQuery(input, { enabled: !!accountId });

  const { mutateAsync: createWebhook, isLoading: isCreating } = trpc.createAccountWebhook.useMutation({
    onSuccess: invalidateWebhooks,
  });
  const { mutateAsync: updateWebhook, isLoading: isUpdating } = trpc.updateAccountWebhook.useMutation({
    onSuccess: invalidateWebhooks,
  });
  const { mutateAsync: deleteWebhook, isLoading: isDeleting } = trpc.deleteAccountWebhook.useMutation({
    onSuccess: invalidateWebhooks,
  });
  const { mutateAsync: testWebhook } = trpc.testAccountWebhook.useMutation();

  return {
    webhooks,
    isLoading,
    createWebhook,
    updateWebhook,
    deleteWebhook,
    testWebhook,
    isCreating,
    isUpdating,
    isDeleting,
  };
};
